module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fvK5A"))).then(() => parcelRequire('hEqeo'));